import { useTranslation } from "react-i18next";
import { NeuSelect } from "../../components/neu/Neu";

const TYPES = ["cashbox", "bank_account"];

// اختيار مصدر الصرف: نوع (صندوق/بنك) + القائمة مفلترة بالنوع مع الرصيد الظاهر — إجباري.
export const SourcePicker = ({ boxes, branchId, type, id, onChange }) => {
  const { t } = useTranslation();
  const options = boxes.filter(
    (b) => (b.kind === "bank") === (type === "bank_account") && (!branchId || !b.branch_id || b.branch_id === branchId),
  );

  return (
    <>
      <label className="grid gap-1 text-xs font-bold">
        {t("bonus.fields.sourceType")}
        <NeuSelect data-testid="bonus-source-type" value={type}
                   onChange={(e) => onChange({ payment_source_type: e.target.value, payment_source_id: "" })}>
          {TYPES.map((key) => (
            <option key={key} value={key}>{t(`bonus.sourceType.${key}`)}</option>
          ))}
        </NeuSelect>
      </label>
      <label className="grid gap-1 text-xs font-bold">
        {t("bonus.fields.source")} <span className="text-destructive">*</span>
        <NeuSelect data-testid="bonus-source-id" value={id}
                   onChange={(e) => onChange({ payment_source_type: type, payment_source_id: e.target.value })}>
          <option value="">{t("bonus.fields.pickSource")}</option>
          {options.map((b) => (
            <option key={b.id} value={b.id}>{b.name} · {b.balance} {b.currency || ""}</option>
          ))}
        </NeuSelect>
      </label>
    </>
  );
};
